<template>
  <div class="mt-2 flex  overflow-hidden flex-grow ">
    <div class="overflow-hidden  flex flex-col pb-4 flex-grow bg-trader-gray mr-2 ">

      <!--go back  -->
      <div class="w-full  h-10 ">
        <CGoBack/>
      </div>

      <!--Bearbeitung Weißer hintergrund  -->
      <div class=" flex-grow overflow-hidden px-10 h-full  flex  text-center justify-center">

        <div class=" overflow-auto bg-white rounded p-10  max-w-[1000px] flex-grow">

          <div class="flex-shrink-0 flex items-center justify-between w-full h-10 mb-4 rounded">
            <div class="w-full bg-primary p-2 rounded">
              <span class="text-xl">Neuen Benutzer Erstellen</span>
            </div>
          </div>

          <div class="flex-grow flex flex-col space-y-4 overflow-auto">

            <div class="flex space-x-2">
              <span class="bg-primary w-[200px] p-2 rounded">Name</span>
              <input class="border p-2 rounded w-full" required v-model="name" :class="{'border p-2 rounded w-full border-red-500' : showError && !this.name}" data-ui="username">
            </div>

            <div class="flex space-x-2 my-2">
              <span class="bg-primary w-[200px] p-2 rounded">Passwort</span>
              <input type="password" class="border p-2 rounded w-full" required v-model="password" :class="{'border p-2 rounded w-full border-red-500' : showError && !this.password}" data-ui="password">
            </div>

            <div class="flex space-x-2">
              <span class="bg-primary w-[200px] p-2 rounded">Passwort erneut</span>
              <input type="password" class="border p-2 rounded w-full" required v-model="passwordAgain" :class="{'border p-2 rounded w-full border-red-500' : showError && !this.passwordAgain}" data-ui="repeat-password">
            </div>

            <div class="flex space-x-2">
              <span class="bg-primary w-[200px] p-2 rounded">E-Mail</span>
              <input class="border p-2 rounded w-full" v-model="mail" :class="{'border p-2 rounded w-full border-red-500' : showError && !this.mail}" data-ui="email">
            </div>

            <div class="flex space-x-2 my-2">
              <span class="bg-primary w-[200px] p-2 rounded">Telefonnummer</span>
              <input class="border p-2 rounded w-full" v-model="phone" data-ui="phone-number">
            </div>

            <div class="flex space-x-2">
              <span class="bg-primary w-[200px] p-2 rounded">Sprache</span>
              <select class="border p-2 rounded w-full" v-model="language" data-ui="choose-language">
                <option>De</option>
                <option>En</option>
              </select>
            </div>
            <div class="flex grid-cols-3 w-full gap-2 mt-2">
              <button data-ui="role-admin"
                  class="w-full px-4 py-2  hover:bg-trader-blue hover:text-white rounded"
                  :class="selectedRole === 1 ? 'bg-green-500' : 'bg-trader-gray'"
                  @click="setRole(1)">
                Administrator
              </button>
              <button data-ui="role-marketing"
                  class="px-4 w-full py-2 rounded -gray hover:bg-trader-blue hover:text-white"
                  :class="selectedRole === 0 ? 'bg-green-500' : 'bg-trader-gray'"
                  @click="setRole(0)">
                Marketing
              </button>
              <button data-ui="role-purchaser"
                  class="px-4 w-full py-2  rounded  hover:bg-trader-blue hover:text-white"
                  :class="selectedRole === 15 ? 'bg-green-500' : 'bg-trader-gray'"
                  @click="setRole(15)">
                Einkäufer
              </button>
            </div>

            <button class="w-full rounded mt-2 p-3 bg-primary hover:bg-trader-blue hover:text-white transition duration-200 ease-in-out" @click="createUser" data-ui="create-new-user-button">Benutzer Erstellen</button>

            <div class="w-full rounded mt-2 text-center" v-if="passwortWrong">
              <span data-ui="non-matching-passwords-notice" >Passwörter stimmen nicht über ein </span>
            </div>


          </div>
        </div>
      </div>
    </div>


    <Sidebar />
  </div>
</template>

<script>
import {gql} from "@apollo/client/core";
import apolloClient from "../../../apolloClient";
import AccordionItem from "@/components/Accordion/AccordionItem.vue";
import ProductFormular from "@/components/ProductFormular/ProductFormular.vue";
import Accordion from "@/components/Accordion/Accordion.vue";
import ProductHeader from "@/components/ProductFormular/ProductHeader.vue";
import PageGrid from "@/components/PageGrid/PageGrid.vue";
import router from "@/router";
import Sidebar from "@/components/Administration/Sidebar.vue";
import CreatProjekt from "@/components/Administration/Project/CreatProjekt.vue";
import {eventBus} from "@/application/EventBus";
import SuccessConfirmation from "@/components/Dialogs/SuccessConfirmation.vue";
import CGoBack from "@/components/Administration/CGoBack.vue";

export default {
  components: {
    CGoBack,
    CreatProjekt, Sidebar, ProductHeader, Accordion, ProductFormular, AccordionItem, PageGrid, SuccessConfirmation},
  data() {
    return {
      name: "",
      password: "",
      passwordAgain: "",
      mail: "",
      phone: "",
      language: "",
      passwortWrong: false,
      showError: false,
      selectedRole: 0,
      accordionIndex: 0,
    };
  },
  methods: {
    goBack(){
      router.push(`/administration`);
    },
    setRole(role) {
      this.selectedRole = role;
    },
    async createUser() {

      if(!this.name || !this.password || !this.passwordAgain || !this.mail){
        this.showError = true;
        return;
      }
      this.showError = false;

      if(this.password == this.passwordAgain){
        const userData = {
          name: this.name,
          password: this.password,
          mail: this.mail,
          phone: this.phone,
          language: this.language,
          role : this.selectedRole
        };


        const mutation = gql`
        mutation createUser($user: UserInput!) {
          createUser(user: $user) {
            success
          }
        }
      `;

        try {
          const variables = {
            user: userData
          };
          const {data} = await apolloClient.mutate({mutation, variables});

          if (data.createUser.success){
            // open modal
            eventBus.openModal(SuccessConfirmation);
            eventBus.setData({
              title: "Benutzer erstellt",
              message: "Der Benutzer wurde erstellt",
            });
            router.push(`/administration/${this.accordionIndex}`);
          }
        } catch (error) {
          console.error(error);
        }
      }else{
        this.passwortWrong = true;
      }
    }
  },
  watch: {
    // get accordionIndex from url
    '$route.params.accordionIndex': function (newId, oldId) {
      this.accordionIndex = newId;
    },
  },
  created() {
    this.accordionIndex = this.$route.params.accordionIndex;
  }
};
</script>
